import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ListaService } from '../../_services/lista.service';
import { ProductoEstadoRelacionCausalService } from '../../_services/producto-estado-relacion-causal.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { ProductoEstadoRelacionNotificacionService } from '../../_services/producto-estado-relacion-notificacion.service';
import { NotificacionesService } from '../../_services/notificaciones.service';
import { forkJoin } from 'rxjs';
import { CanalService } from '../../_services/canal.service';
import { EstadoService } from '../../_services/estado.service';
import { ConfiguracionesCanales } from '../../_models/configuraciones-canales';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfiguracionesCanalesService } from '../../_services/configuraciones-canales.service';
import { Location } from '@angular/common';
import moment from 'moment';
import 'moment/locale/es';
import { FlujoVentaPaso } from '../../_models/flujo-venta-paso';
import { ConfiguracionCanalFlujoVentaPaso } from '../../_models/configuracion-canal-flujo-venta-paso';
import { FlujoVentaPasoService } from '../../_services/flujo-venta-paso.service';
import { ConfiguracionCanalFlujoVentaPasoService } from '../../_services/configuracion-canal-flujo-venta-paso.service';
import { Pasos } from '../../_enums/enum';
import { ConfiguracionCanalFlujoVentaPasoControlProducto } from '../../_models/configuracion-canal-flujo-venta-paso-control-producto';
import { Producto } from '../../_models/producto';
import { FlujoVentaPasoControl } from '../../_models/flujo-venta-paso-control';
import { FlujoVentaPasoControlService } from '../../_services/flujo-venta-paso-control.service';
import { ProductoService } from '../../_services/producto.service';
import { ConfiguracionCanalFlujoVentaPasoControlProductoService } from '../../_services/configuracion-canal-flujo-venta-paso-control-producto.service';

@Component( {
  selector: 'app-canal-estado-paso-control-producto',
  templateUrl: 'canal-estado-paso-control-producto.component.html'
} )

export class CanalEstadoPasoControlProductoComponent implements OnInit {

  @Input() configuracionCanalPaso: ConfiguracionCanalFlujoVentaPaso;
  @Input() editar: true;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  formularioPasosControles: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  carInformacionInicial = true;
  controles: FlujoVentaPasoControl[] = [];
  productos: Producto[] = [];
  listaControles: SelectItem[] = [];
  listaProductos: SelectItem[] = [];
  listaCanalPasoControlesProductos: any[] = [];
  listaCanalPasoControlesProductosTodos: ConfiguracionCanalFlujoVentaPasoControlProducto[] = [];
  carTabla = true;
  showTable = false;
  controlProductoEditar: any;
  controlEdicion: string;

  get fControls() {
    return this.formularioPasosControles.controls;
  }

  constructor( private navServicio: NavService,
               private conServicio: ConfirmationService,
               private proEstadoCambioServicio: ProductoEstadoRelacionService,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private proEstadoRelacionCausalServicio: ProductoEstadoRelacionCausalService,
               private tipCausalesService: TipoCausalCausalSolicitudService,
               private funServicio: FuncionalidadesService,
               private proEstadoRelacionNotificacionServicio: ProductoEstadoRelacionNotificacionService,
               private notServicio: NotificacionesService,
               private canalService: CanalService,
               private estadoService: EstadoService,
               private activeRoute: ActivatedRoute,
               private configCanalService: ConfiguracionesCanalesService,
               private location: Location,
               private fluVentaPasoService: FlujoVentaPasoService,
               private canalPasoService: ConfiguracionCanalFlujoVentaPasoService,
               private fluVentaPasoControlService: FlujoVentaPasoControlService,
               private productoService: ProductoService,
               private configCanalFluVentaPasoControlProdService: ConfiguracionCanalFlujoVentaPasoControlProductoService) {
  }

  ngOnInit(): void {
    this.cargarEncabezadoTabla();
    this.cargarDatos();
  }

  cargarEncabezadoTabla() {
    this.columnas = [
      { field: 'codigoControl', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_CAMPO' ), sort: true },
      { field: 'nombreControl', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_NOMBRECAMPO' ), sort: true },
      { field: 'indicadorVisible', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_VISIBLE' ), sort: true },
      { field: 'productos', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_PRODUCTO' ), sort: true }
    ];
    if ( this.editar ) {
      this.columnas.push({ field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false });
    }
  }

  cargarDatos() {
    forkJoin(
      this.fluVentaPasoControlService.listadoPorIdFlujoPaso(this.configuracionCanalPaso.idFlujoVentaPaso),
      this.productoService.listadoHabilitados()
    ).subscribe(async ([flujoVentaPasoControles, productos]) => {
      productos = productos.sort(function (a, b) {
        return a.orden - b.orden;
      });
      this.productos = productos;
      this.controles = flujoVentaPasoControles;
      productos.map( p => {
        const item = { label: p.nombre, value: p.idProducto };
        this.listaProductos.push(item);
      });
      await this.cargarDatosTabla();
      this.cargarFormulario();
      this.carInformacionInicial = false;
      //this.showTable = true;
      this.carTabla = false;
    });
  }

  async cargarDatosTabla() {
    this.showTable = false;
    this.carInformacionInicial = true;
    this.configCanalFluVentaPasoControlProdService.listadoPorIdConfiguracionCanalPaso(this.configuracionCanalPaso.idConfiguracionCanalFlujoVentaPaso).subscribe( controlesProducto => {
      this.listaCanalPasoControlesProductosTodos = controlesProducto;
      this.crearListaCustom();
      // this.listaCanalPasoControlesProductos = controlesProducto.filter( x => x.indicadorHabilitado);

      this.listaControles = [];
      this.controles.map( c => {
        const existeHabilitado = this.listaCanalPasoControlesProductos.find( x => x.idFlujoVentaPasoControl === c.idFlujoVentaPasoControl );
        if ( !existeHabilitado ) {
          const item = { label: `${c.codigoFuncionalidadControl} - ${c.funcionalidadControl}`, value: c.idFlujoVentaPasoControl };
          this.listaControles.push(item);
        }
      });
      this.showTable = true;
      this.carInformacionInicial = false;
    });
    return true;
  }

  cargarFormulario() {
    this.formularioPasosControles = this.fb.group( {
      idFlujoVentaPasoControl: [ this.controlProductoEditar ? this.controlProductoEditar.idFlujoVentaPasoControl  : null, [Validators.required] ],
      idProductos: [ this.controlProductoEditar ? this.controlProductoEditar.productos  : null, [Validators.required] ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formularioPasosControles.valid ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_GUARDARPRODUCTOSCONTROL' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'productos-controles',
        accept: () => {
          this.guardarPasosConfiguracionCanalControlesProducto();
        },
        reject: () => {
        }
      } );
    }
  }

  guardarPasosConfiguracionCanalControlesProducto() {
    this.guardando = true;
    const productosEscogidos = this.fControls.idProductos.value;
    const listaGuardar = this.armarListaBulk(productosEscogidos);
    this.configCanalFluVentaPasoControlProdService.bulk( listaGuardar ).subscribe( async resp => {
      this.formularioPasosControles.reset();
      if ( this.controlProductoEditar ) {
        this.showMessage('LBL_INFORMACION', 'Se han actualizado la configuración de forma exitosa!', 'success');
      } else {
        this.showMessage('LBL_INFORMACION', 'Se han guardado la configuración de forma exitosa!', 'success');
      }
      this.controlProductoEditar = null;
      this.controlEdicion = null;
      this.submitted = false;
      this.guardando = false;
      await this.cargarDatosTabla();
    }, e => {
      this.guardando = false;
    });
  }

  armarListaBulk(idProductosEscogidos: string[]) {
    let listaBulk = [];
    const productosControlInhabilitado = this.getListaProductosControlInhabilitados();
    const controlProductoInhabilitar = this.controlProductoEditar ? this.controlProductoEditar.productos.filter( x => idProductosEscogidos.indexOf(x) === -1) : [];
    const listaAgregar = this.llenarListaGuardar(idProductosEscogidos, false, productosControlInhabilitado);
    if ( listaAgregar.length > 0 ) {
      const listaInhabilitar = this.llenarListaGuardar(controlProductoInhabilitar, true, []);
      listaBulk = listaAgregar.concat(listaInhabilitar);
    } else {
      listaBulk = listaAgregar;
    }
    return listaBulk;
  }

  llenarListaGuardar(lista: string[], inhabilitar = false, prodControlInhabilitado: any[]) {
    const listaReturn = [];
    lista.map( idProducto => {
      let existe;
      if ( prodControlInhabilitado.length > 0 ) {
        existe = this.listaCanalPasoControlesProductosTodos.find( x => x.idProducto === idProducto && x.idFlujoVentaPasoControl === this.fControls.idFlujoVentaPasoControl.value);
      } else {
        existe = this.controlProductoEditar ? this.listaCanalPasoControlesProductosTodos.find( x => x.idProducto === idProducto && x.idFlujoVentaPasoControl === this.controlProductoEditar.idFlujoVentaPasoControl) : null;
      }
      const objGuardar = {
        idConfiguracionesCanalesFlujoVentaPasosControlesProductos: existe ? existe.idConfiguracionesCanalesFlujoVentaPasosControlesProductos : null,
        idConfiguracionCanalFlujoVentaPasos: this.configuracionCanalPaso.idConfiguracionCanalFlujoVentaPaso,
        idProducto: idProducto,
        idFlujoVentaPasoControl: this.controlProductoEditar ? this.controlProductoEditar.idFlujoVentaPasoControl : this.fControls.idFlujoVentaPasoControl.value,
        indicadorHabilitado: !inhabilitar,
        auditoriaFecha: new Date(moment().format())
      } as ConfiguracionCanalFlujoVentaPasoControlProducto;

      listaReturn.push(objGuardar);
    });
    return listaReturn;
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje )
    } );
  }

  editarProductosControl(record: any) {
    this.controlProductoEditar = record;
    const control = this.controles.find( x => x.idFlujoVentaPasoControl === record.idFlujoVentaPasoControl )
    this.controlEdicion = control ? `${control.codigoFuncionalidadControl} - ${control.funcionalidadControl}` : null;
    this.cargarFormulario();
    this.formularioPasosControles.markAsDirty();
  }

  inhabilitarProductosControl(record: any) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_INHABILITARPRODUCTOSCONTOL' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'productos-controles',
      accept: () => {
        const listaInhabilitar = this.armarListaInhabilitar(record.idFlujoVentaPasoControl, record.productos);
        this.configCanalFluVentaPasoControlProdService.bulk(listaInhabilitar).subscribe( resp => {
          this.formularioPasosControles.reset();
          this.showMessage('LBL_INFORMACION', 'Se ha eliminado la configuración de forma exitosa!', 'success');
          this.controlEdicion = null;
          this.controlProductoEditar = null;
          this.cargarDatosTabla();
        });
      },
      reject: () => {
      }
    } );
  }

  crearListaCustom() {
    this.listaCanalPasoControlesProductos = [];
    this.listaCanalPasoControlesProductosTodos.map( cpcp => {
      if ( cpcp.indicadorHabilitado ) {
        const addedIndex = this.listaCanalPasoControlesProductos.findIndex( x => x.idFlujoVentaPasoControl === cpcp.idFlujoVentaPasoControl );
        if ( addedIndex > -1 ) {
          this.listaCanalPasoControlesProductos[addedIndex].productos.push(cpcp.idProducto);
          this.listaCanalPasoControlesProductos[addedIndex].nombreProductos += ' - ' + cpcp.nombreProducto;
        } else {
          const objCustom: any = Object.assign({}, cpcp.flujoVentaPasosControles);
          objCustom.productos = [ cpcp.idProducto ];
          objCustom.nombreProductos = cpcp.nombreProducto;
          this.listaCanalPasoControlesProductos.push(objCustom);
        }
      }
    });
  }

  armarListaInhabilitar(idFlujoVentaPasoControl: string, idProductos: string[]) {
    const listaReturn = [];
    idProductos.map( idProducto => {
      const existe = this.listaCanalPasoControlesProductosTodos.find( x => x.idProducto === idProducto && x.idFlujoVentaPasoControl === idFlujoVentaPasoControl);
      if ( existe ) {
        existe.indicadorHabilitado = false;
      }

      listaReturn.push(existe);
    });
    return listaReturn;
  }

  getListaProductosControlInhabilitados() {
    let actuales = [];
    const existeHabilitado = this.listaCanalPasoControlesProductos.find( x => x.idFlujoVentaPasoControl === this.fControls.idFlujoVentaPasoControl.value );
    if ( !existeHabilitado ) {
      actuales = this.listaCanalPasoControlesProductosTodos.filter( x => x.idFlujoVentaPasoControl === this.fControls.idFlujoVentaPasoControl.value );
    }
    return actuales;
  }

  cancelarEdicion(dirtyForm: boolean) {
    if ( dirtyForm ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_CANCELAREDICION' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'productos-controles',
        accept: () => {
          this.controlProductoEditar = null;
          this.controlEdicion = null;
          this.formularioPasosControles.reset();
        },
        reject: () => {
        }
      } );
    } else {
      this.controlProductoEditar = null;
      this.controlEdicion = null;
      this.formularioPasosControles.reset();
    }
  }

}
